<template>
  <div class="latest-news-box">
    <!-- 最新消息 -->
    <div class="the-body-box">
      <!-- <div class="news-banner-box gray-box common-flex-box">
        <el-carousel height="442PX" class="banner-list" arrow="never">
          <el-carousel-item v-for="item in 3" :key="item">
            <img class="img" src="../../../../assets/img/news-bg.png" alt="">
          </el-carousel-item>
        </el-carousel>
        <div class="banner-text-box">
          <div class="banner-title">艺术大师刘某某，加盟经艺联，13张作品国画作品——《啥》《啥啥啥》等，9月优惠出售中</div>
          <div class="time text-light-gray">2019/06/17</div>
          <div class="banner-content">近日，草间弥生和村上隆两位艺术家在中国美术界真真切切地“被”火了一把。据了解，自2018年4月起，以“草间弥生和村上隆藏品双联展”字样命名的展览先后在深圳、广州、武汉、上海、长沙等多地举办，近日却被爆料展览“有可能是假的”。</div>
        </div>
      </div> -->
      <div class="news-list-box">
        <div class="news-item gray-box" v-for="(item, i) in newsList" :key="i">
          <router-link
            :to="`/news-detail?informationId=${item.informationId}`"
            class="common-flex-box"
          >
            <img :src="item.logoPath" class="news-img" />
            <div class="right-text-box">
              <div class="news-title ellipsis" v-html="item.chTitle"></div>
              <div class="news-content" v-html="item.chAbstract"></div>
              <div class="text-light-gray">{{ item.createTime }}</div>
            </div>
          </router-link>
        </div>
      </div>
      <pc-pagination
        :pagOption="options"
        @current="informationList"
      ></pc-pagination>
    </div>
  </div>
</template>
<!-- Global site tag (gtag.js) - Google Analytics -->
<script async src="https://www.googletagmanager.com/gtag/js?id=G-7CH9447NP2"></script>
<script>
import pcPagination from "@/components/pagination";
export default {
  components: {
    pcPagination,
  },
  data() {
    return {
      newsList: [],
      options: {
        total: null,
        size: null,
        current: null,
        pages: null,
      },
      query: {
        cursor: 1,
        limit: 9,
      },
    };
  },
  created() {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag("js", new Date());

    gtag("config", "G-7CH9447NP2");
  },
  mounted() {
    this.informationList();
  },
  methods: {
    informationList(page) {
      if (page) this.query.cursor = page;
      let data = {
        cursor: this.query.cursor,
        limit: this.query.limit,
      };
      this.$commonPromise("get", this.$Api.informationList, data).then(
        (res) => {
          if (res.code === 200) {
            this.newsList = res.data.records;
            this.options.total = res.data.total;
            this.options.size = res.data.size;
            this.options.current = res.data.current;
            this.options.pages = res.data.pages;
          }
        }
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.latest-news-box {
  .gray-box {
    background-color: #f7f7f7;
  }
  .news-banner-box {
    margin: 28PX 0 64PX;
    .banner-list {
      flex: 0 0 590PX;
      overflow: hidden;
    }
    .banner-text-box {
      flex: 1;
      padding: 38PX 78PX 0 38PX;
      .banner-title {
        font-size: 18PX;
        font-weight: bold;
        line-height: 1.4;
      }
      .time {
        margin: 30PX 0 39PX;
      }
      .banner-content {
        line-height: 1.8;
      }
    }
  }
  .news-list-box {
    padding-bottom: 64PX;
    a {
      color: #333;
    }
    .news-item {
      height: 300PX;
      // background-color: #fff;
      &:not(:first-child) {
        margin-top: 40PX;
      }
      .news-img {
        width: 500PX;
        flex: 0 0 500PX;
        height: 300PX;
        object-fit: cover;
      }
      .right-text-box {
        flex: 1;
        padding: 60PX 110PX 24PX 79PX;
        .news-title {
          font-size: 16PX;
          font-weight: bold;
        }
        .news-content {
          margin: 38PX 0 8PX;
          height: 140PX;
          line-height: 1.7;
          overflow: hidden;
        }
      }
    }
  }
  // .pagination-box {
  //   padding: 40PX 0;
  //   border-top: 1PX solid #ddd;
  // }
}
</style>